import React from 'react';

type Props = {
    infoMessage?: string | null;
    errorMessage?: string | null;
    nextUrl: string;
    agentValue: string;
    changePasswordRequired: boolean;
    action: string;
};

export const LoginCard: React.FC<Props> = ({
    infoMessage,
    errorMessage,
    nextUrl,
    agentValue,
    changePasswordRequired,
    action,
}) => {
    return (
        <main className="login-layout" role="main">
            <section className="login-card" aria-labelledby="login-title">
                <h1 id="login-title" className="login-heading">
                    MVNO Console
                </h1>
                <p className="login-subtitle">서비스에 접근하려면 인증 정보를 입력해주세요.</p>

                {infoMessage ? (
                    <div className="login-alert login-alert--info" role="status">
                        {infoMessage}
                    </div>
                ) : null}
                {errorMessage ? (
                    <div className="login-alert login-alert--error" role="alert">
                        {errorMessage}
                    </div>
                ) : null}

                <form method="POST" action={action} className="login-form" noValidate>
                    <input type="hidden" name="next" value={nextUrl} />
                    <div className="login-field">
                        <label className="login-label" htmlFor="agent">
                            로그인 아이디
                        </label>
                        <input
                            id="agent"
                            name="agent"
                            className="login-input"
                            type="text"
                            placeholder="로그인 아이디"
                            maxLength={64}
                            defaultValue={agentValue}
                            autoComplete="username"
                            autoFocus
                            required
                        />
                    </div>
                    <div className="login-field">
                        <label className="login-label" htmlFor="password">
                            Password
                        </label>
                        <input
                            id="password"
                            name="password"
                            className="login-input"
                            type="password"
                            placeholder="비밀번호"
                            maxLength={128}
                            autoComplete="current-password"
                            required
                        />
                    </div>
                    {changePasswordRequired ? (
                        <>
                            <div className="login-field">
                                <label className="login-label" htmlFor="new_password">새 비밀번호</label>
                                <input id="new_password" name="new_password" className="login-input"
                                    type="password" minLength={12} maxLength={128}
                                    autoComplete="new-password" required />
                            </div>
                            <div className="login-field">
                                <label className="login-label" htmlFor="confirm_password">새 비밀번호 확인</label>
                                <input id="confirm_password" name="confirm_password" className="login-input"
                                    type="password" minLength={12} maxLength={128}
                                    autoComplete="new-password" required />
                            </div>
                        </>
                    ) : null}
                    <button type="submit" className="login-submit">
                        {changePasswordRequired ? '비밀번호 변경 후 로그인' : '로그인'}
                    </button>
                </form>

                <p className="login-footnote">활동이 없으면 자동으로 로그아웃됩니다.</p>
            </section>
        </main>
    );
};
